var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start flex-wrap gap-y-3 col-span-7"},[_vm._l((_vm.validNewChanges),function(value,key){return [(!_vm.isTheSame(value, _vm.validOldChanges[key]))?_c('EventChange',{key:key,staticClass:"mr-3",attrs:{"label":key,"value":value,"old":_vm.validOldChanges[key]}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }